import { Injectable } from '@angular/core';
import { AuthServiceBase } from '../services/auth/auth.service.base';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private authService: AuthServiceBase) {}
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      this.authService.login().catch((error) => {
        console.error('Login failed:', error);
      });
      return false;
    }
    return true;
  }
}